import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import MUIThemeProvider from "./context/themeProvider";
import { BrowserRouter } from "react-router-dom";
import { LangContextProvider } from "./context/langContext";
import { AuthContextProvider } from "./context/authContext";
import { NotificationContextProvider } from "./context/notificationContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <MUIThemeProvider>
      <NotificationContextProvider>
        <BrowserRouter>
          <LangContextProvider defaultLang="fa">
            <AuthContextProvider>
              <App />
            </AuthContextProvider>
          </LangContextProvider>
        </BrowserRouter>
      </NotificationContextProvider>
    </MUIThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
